/* eslint-disable */
export default {
  copy: 'Kopioi',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
